<template>
  <v-app>
    <v-navigation-drawer v-model="drawer" app temporary >
      <v-list>
        <v-list-tile avatar>
             <v-list-tile-avatar>
            <img src="http://ldm.io/imgL/ldpic3.png" >
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title>
              <span>Lucas Di Monte</span>
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-divider></v-divider>
        <template v-for="(item, index) in items">
          <v-list-tile :href="item.href" :to="{name: item.href}" :key="index">
            <v-list-tile-action>
              <v-icon light v-html="item.icon"></v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title v-html="item.title"></v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </template>
      </v-list>
    </v-navigation-drawer>
    <v-toolbar class="white"  app :fixed="fixed" dense flat>
      <!-- menu icon -->
        <v-tooltip bottom>
      <v-toolbar-side-icon @click.stop="drawer = !drawer"   slot="activator"></v-toolbar-side-icon>
         <span>Menu</span>
    </v-tooltip>
      <!-- <v-toolbar-title></v-toolbar-title> -->
      <v-spacer></v-spacer>
      <!-- git icon -->
                <v-tooltip bottom>
      <v-btn
      icon @click.native.stop="openGithub()"
      slot="activator">
        <v-icon>fa-github-square fa-2x</v-icon>
             </v-btn>
             <span>Github</span>
    </v-tooltip>
    <!-- codepen icon -->
     <v-tooltip bottom>
      <v-btn 
  icon @click.native.stop="openCode()"
      slot="activator">
 <v-icon>fa-codepen fa-2x</v-icon>
 </v-btn>
     <span>Codepen</span>
    </v-tooltip>
    <!-- instagram icon -->
     <v-tooltip bottom>
   <v-btn icon @click.native.stop="openInsta()"
       slot="activator">
        <v-icon>fa-instagram fa-2x</v-icon>
   </v-btn>
       <span>Instagram</span>
    </v-tooltip>
   <!-- linkedin icon -->
     <v-tooltip bottom>
   <v-btn icon @click.native.stop="openLinked()"
       slot="activator">
        <v-icon>fa-linkedin fa-2x</v-icon>
   </v-btn>
       <span>Linkedin</span>
    </v-tooltip>



    </v-toolbar>
              <v-content>
          <v-fade-transition mode="out-in">
                 <main>
            <v-btn
        
          fixed
          bottom
          right
          fab
        ripple
         color="pink"
         dark
         
                       >
                <v-icon>menu</v-icon>
              </v-btn>
        <router-view></router-view>
        </main>
      </v-fade-transition>
    </v-content>
    <!-- <v-footer class="indigo pa-3" dark app>
      <span>© 2018 - <a href="https://github.com/disjfa" class="indigo text--lighten-5">disjfa</a></span>
    </v-footer> -->
  </v-app>
</template>

<script type="text/babel">
export default {
  data() {
    return {
      drawer: false,
      fixed: true,
      // hidden:false,
           items: [{
        href: 'home',
        router: true,
        title: 'Home',
        icon: 'home',
      }, {
        href: 'examples',
        router: true,
        title: 'Example',
        icon: 'extension',
      }, {
        href: 'about',
        router: true,
        title: 'About',
        icon: 'domain',
      }, {
        href: 'test',
        router: true,
        title: 'Tests',
        icon: 'domain',
      }
      
      
      ],
    };
  },
  methods: {
    openGithub() {
      window.open('https://github.com/disjfa/vuetify-sidebar-template');
    },
  },
};
</script>

<style lang="stylus">
  @import '../node_modules/vuetify/src/stylus/main';
  @import 'css/main.css';
  
  main {
    padding: 0%;
    
  }

 /* 1em = 10px */
.toolbar {
  margin-left:0%;
    
  }
  
#app > div.application--wrap > nav > div > span:nth-child(1){
  margin-left:1.2%;
 }


#app > div.application--wrap > nav > div > span:nth-child(6){
  margin-right:1%;
}

</style>
